export enum FontSize {
  XXL = '2.625rem', // 42px
  XL = '2rem', // 32px
  L = '1.3125rem', // 21px
  M = '0.9375rem', // 15px
  SM = '0.75rem', // 12px
  XS = '0.6875rem', // 11px
  XXS = '0.4375rem', // 7px
}
